import { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Thin animated loading bar at the top of the screen (like YouTube/GitHub)
// Much smoother than a full-screen spinner on slow connections
export function RouteProgressBar() {
  const location = useLocation();
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const timerRef = useRef(null);
  const prevPath = useRef(location.pathname);

  useEffect(() => {
    if (location.pathname === prevPath.current) return;
    prevPath.current = location.pathname;

    // Start progress bar
    setVisible(true);
    setProgress(15);

    // Simulate fast initial progress, slow middle, fast finish
    let p = 15;
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      if (p < 60) p += 8;
      else if (p < 85) p += 2;
      else if (p < 95) p += 0.5;
      setProgress(p);
      if (p >= 95) clearInterval(timerRef.current);
    }, 100);

    // Complete after a short delay (route rendered)
    const completeTimer = setTimeout(() => {
      clearInterval(timerRef.current);
      setProgress(100);
      setTimeout(() => {
        setVisible(false);
        setProgress(0);
      }, 300);
    }, 600);

    return () => {
      clearInterval(timerRef.current);
      clearTimeout(completeTimer);
    };
  }, [location.pathname]);

  if (!visible && progress === 0) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] h-[2.5px] pointer-events-none" data-testid="route-progress-bar">
      <div
        className="h-full bg-gradient-to-r from-cyan-400 via-blue-500 to-cyan-400 shadow-[0_0_8px_rgba(34,211,238,0.6)]"
        style={{
          width: `${progress}%`,
          transition: progress === 0 ? "none" : progress === 100 ? "width 200ms ease-out, opacity 300ms ease-out" : "width 300ms ease-out",
          opacity: progress === 100 ? 0 : 1,
        }}
      />
    </div>
  );
}
